import type { NonNullableFormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { type ControlInterface, enumValidator } from '@comparit/core';
import {
  type BauartklasseLabel,
  Bauweise,
  Dacheindeckung,
  Fertighaus,
  type Step6FormInput,
} from '../../../interfaces';
import { findBauartklasse } from '../bauartklasse-identifier';

export class Step6Form {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: Step6FormInput | null
  ) {}

  ctrls: ControlInterface<Step6FormInput> = {
    dacheindeckung: this.fb.control<Dacheindeckung>(
      this.defaultValue?.dacheindeckung ?? Dacheindeckung.HarteBedachung,
      [Validators.required, enumValidator(Dacheindeckung)]
    ),
    bauweiseAussenwaende: this.fb.control<Bauweise>(
      this.defaultValue?.bauweiseAussenwaende ?? Bauweise.Massiv,
      [Validators.required, enumValidator(Bauweise)]
    ),
    fertighaus: this.fb.control<Fertighaus>(this.defaultValue?.fertighaus ?? Fertighaus.Nein, [
      Validators.required,
      enumValidator(Fertighaus),
    ]),
  };

  /** The readout under the three questions; the Sparte derives its own from the same answers. */
  getBauartklasse(): BauartklasseLabel | null {
    return findBauartklasse(
      this.ctrls.fertighaus.value,
      this.ctrls.dacheindeckung.value,
      this.ctrls.bauweiseAussenwaende.value
    );
  }

  public fg = this.fb.group(this.ctrls);
}
